export default {
  dropZoneWrapper: {
    boxShadow: '0  0 0 1px rgb(0 0 0 / 10%)',
  },
  fileDropZoneContainer: {
    marginBottom: '24px',
  },
  fileWrapper: {
    height: '180px',
    minHeight: '180px',
    borderRadius: '10px',
  },
};
